import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchOrder = async (orderReference: string) => {
  const res = await api().gersGetOrder(orderReference);

  return res.data;
};

export const useOrder = (orderReference: string, type: string) => {
  const {
    data: order,
    isFetching: isOrderFetching,
    isError: orderError,
    refetch: refetchOrder,
  } = useQuery({
    queryKey: [`get-order-${orderReference}`],
    queryFn: () => fetchOrder(orderReference),
    enabled: orderReference !== "" && type !== "p",
    refetchOnWindowFocus: false,
    retry: 1,
    onSuccess: (data) => {
      // Modify the warrantyPackage field
      if (!data?.warrantyPackage?.packageId) {
        data.warrantyPackage = undefined;
      }
    },
  });

  return { order, isOrderFetching, orderError, refetchOrder };
};
